import type { StoreApi } from 'zustand'
import type { SendRawOptions } from './connectionStore'
import type { ChatState } from './chatStore'

export interface InactivityNotice {
  conversationId: string
  pausedAt: number
  resumeContent: string
  resumeOptions?: Omit<SendRawOptions, 'confirmationToken'>
}

export function inactivityNoticeForDisk(notice: InactivityNotice | null): InactivityNotice | null {
  if (!notice?.resumeOptions?.inlineAttachments) return notice
  const resumeOptions = { ...notice.resumeOptions }
  delete resumeOptions.inlineAttachments
  return { ...notice, resumeOptions }
}

export function resumeAfterInactivity(
  get: StoreApi<ChatState>['getState'],
  set: StoreApi<ChatState>['setState'],
): void {
  const { inactivityNotice: notice, inactivityResuming } = get()
  if (!notice || inactivityResuming) return
  set({ inactivityResuming: true })
  void import('./connectionStore')
    .then(({ useConnectionStore }) => {
      const started = useConnectionStore
        .getState()
        .sendRaw(
          notice.conversationId,
          notice.resumeContent,
          crypto.randomUUID(),
          notice.resumeOptions,
        )
      set(
        started
          ? { inactivityNotice: null, inactivityResuming: false }
          : { inactivityResuming: false },
      )
    })
    .catch(() => set({ inactivityResuming: false }))
}
